import { isAxiosError } from 'axios';

import type { DashboardResponse, DashboardTab } from '@/features/dashboard/types';
import { http } from '@/services/http';

import { getDashboardApiUrl, getDashboardShareUrl } from './dashboardUrl';
import { normalizeDashboardEntry } from './normalizeDashboard';

export type DashboardConfig = Record<string, DashboardTab>;

export const normalizeDashboardResponse = (
  data: Record<string, DashboardResponse>
): DashboardConfig =>
  Object.fromEntries(
    Object.entries(data).map(([name, value]) => [name, normalizeDashboardEntry(name, value)])
  );

export const isDashboardNotFoundError = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === 404;

export const fetchDashboardConfig = async (signal?: AbortSignal): Promise<DashboardConfig> => {
  try {
    const { data } = await http.internal.get<Record<string, DashboardResponse>>(
      getDashboardApiUrl(),
      {
        signal
      }
    );
    return normalizeDashboardResponse(data);
  } catch (error) {
    if (isDashboardNotFoundError(error)) return {};
    throw error;
  }
};

export const fetchSharedDashboardConfig = async (
  shareToken: string | null,
  signal?: AbortSignal
): Promise<DashboardConfig> => {
  const { data } = await http.internal.get<Record<string, DashboardResponse>>(
    getDashboardShareUrl(),
    {
      params: { shareToken },
      signal
    }
  );
  return normalizeDashboardResponse(data);
};
